import OptionsButton from "@pathwright/ui/src/components/button/OptionsButton"
import Dropdown from "@pathwright/ui/src/components/dropdown"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import { useQuery } from "@pathwright/web/src/modules/utils/apollo"
import get from "lodash/get"
import DownloadReport from "../../report/DownloadReport"
import useReportUrls from "../../report/graphql/useReportUrls"
import GROUP_RESOURCE_PATH_QUERY from "../graphql/group-resource-path-query"

const Menu = withTranslate(({ cohortId, handleDownloadReport, t, tc }) => {
  const groupQuery = useQuery(GROUP_RESOURCE_PATH_QUERY, {
    variables: {
      id: cohortId
    }
  })

  const {
    groupRegistrationsReportUrl,
    groupPerformancePointsReportUrl,
    groupPerformanceCompletionReportUrl
  } = useReportUrls({
    variables: {
      group_registrations: [
        {
          resource_id: get(groupQuery, "data.group.resource.id"),
          offering_id: get(groupQuery, "data.group.id")
        }
      ],
      group_performance_points: {
        schedule_id: get(groupQuery, "data.group.path.id")
      },
      group_performance_completion: {
        schedule_id: get(groupQuery, "data.group.path.id")
      }
    },
    skip: groupQuery.loading
  })

  // Check for no points error, and disable group_performance_points report if no points exists on path.
  const pathHasPoints =
    groupPerformancePointsReportUrl?.error !== "Path has no points set."

  return (
    <Dropdown.Menu>
      <Dropdown.Divider>{tc("download a csv with")}...</Dropdown.Divider>
      <Dropdown.Item
        icon="download"
        label={tc("learner data")}
        onClick={() => handleDownloadReport(groupRegistrationsReportUrl)}
        download
        closeOnClick
      />
      {pathHasPoints ? (
        <Dropdown.Item
          icon="download"
          label={tc("scores by step")}
          onClick={() => handleDownloadReport(groupPerformancePointsReportUrl)}
          download
          closeOnClick
        />
      ) : (
        <Dropdown.Item
          icon="download"
          label={
            <>
              <span
                style={{
                  textDecoration: "line-through"
                }}
              >
                {tc("scores by step")}
              </span>{" "}
              <span>{t("(no pts set)")}</span>
            </>
          }
          interactive={false}
          closeOnClick={false}
        />
      )}
      <Dropdown.Item
        icon="download"
        label={tc("completion by step")}
        onClick={() =>
          handleDownloadReport(groupPerformanceCompletionReportUrl)
        }
        download
        closeOnClick
      />
    </Dropdown.Menu>
  )
})

const CohortMembersControls = ({ cohortId }) => {
  return (
    <DownloadReport>
      {({ handleDownloadReport }) => (
        <Dropdown.Trigger
          renderDropdown={() => (
            <Menu
              cohortId={cohortId}
              handleDownloadReport={handleDownloadReport}
            />
          )}
        >
          <OptionsButton icon="download" inverted />
        </Dropdown.Trigger>
      )}
    </DownloadReport>
  )
}

export default CohortMembersControls
